/* eslint-disable i18next/no-literal-string -- TanStack cache key segments */
import type { AnalyticsMetricKey, AnalyticsRange } from '../model/types';

/**
 * Keyed by workspace as well as metric and range: switching workspace must show
 * that workspace's numbers, not the previous one's cached series.
 */
export const ANALYTICS_QUERY_KEYS = {
  all: (workspaceId: string) => ['analytics', workspaceId] as const,
  activeUsers: (workspaceId: string, range: AnalyticsRange) =>
    [...ANALYTICS_QUERY_KEYS.all(workspaceId), 'active-users', range] as const,
  sessionDuration: (workspaceId: string, range: AnalyticsRange) =>
    [...ANALYTICS_QUERY_KEYS.all(workspaceId), 'session-duration', range] as const,
  metric: (workspaceId: string, metricKey: AnalyticsMetricKey, range: AnalyticsRange) =>
    [...ANALYTICS_QUERY_KEYS.all(workspaceId), 'metric', metricKey, range] as const,
} as const;
